import { render, staticRenderFns } from "./HtmlContent.vue?vue&type=template&id=ed9c8434&scoped=true"
import script from "./HtmlContent.vue?vue&type=script&lang=js"
export * from "./HtmlContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9c8434",
  null
  
)

export default component.exports